import DialogPage from "../DialogPage";
import {TouchableOpacity} from "react-native";
import {useContext} from "react";
import Text from "../components/Text";
import ServicesList from "../../../components/data-components/ServicesList";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";

export default function Services(props: { navigation: any }) {

    const appFunctions = useContext(AppFunctionsContext);

    return <DialogPage {...props} header={"منوی خدمات"}>

        <ServicesList renderItem={item => {
            return <TouchableOpacity onPress={() => {
                appFunctions.functions.requestService(item.item);
            }}>
                <Text style={{padding: 16}}>{item.item.name}</Text>
            </TouchableOpacity>
        }}/>
    </DialogPage>
}
